<script setup lang="ts">
import {computed} from 'vue';
import {safeLink,externalLink} from '../utils/links';
const props=defineProps<{to?:string}>();
const href=computed(()=>safeLink(props.to));
</script>
<template><RouterLink v-if="href.startsWith('/')" :to="href"><slot /></RouterLink><a v-else-if="href" :href="href" :target="externalLink(href)?'_blank':undefined" :rel="externalLink(href)?'noopener noreferrer':undefined"><slot /></a><span v-else><slot /></span></template>
